import { components } from '@/utils'

import footer from '@/components/services/settings/fields/footer'
import header from '@/components/services/settings/fields/header'

function renderHeader(h, options) {
  return h(
    header,
    {
      props: {
        options,
        label: this.$_label
      }
    }
  )
}

function renderComponent(h, options, item) {
  const { field, component, scopedSlots } = item
  const key = [ options.path, field, 'component' ].filter(Boolean).join('.')

  return h(
    component ?? components['text-field'],
    {
      props: this.getComponentProps(item),
      on: this.getComponentEventHandlers(item),
      scopedSlots,
      key
    }
  )
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: {
        'settings-fields__body': true,
        [`settings-fields__body--cols-${this.cols}`]: true
      }
    },
    [
      this.items.map(item => {
        return renderComponent.call(this, h, options, item)
      })
    ]
  )
}

function renderFooter(h, options) {
  return h(
    footer,
    {
      props: {
        options,
        label: this.$_label,
        description: this.$_description,
        disabled: this.$_disabled,
        dialog: this.dialog,
        showDescription: this.showDescription
      },
      on: {
        input: () => {
          this.transmitValue()
        }
      }
    }
  )
}

export default function(h, options) {
  if (options.permission !== false) {
    return h(
      'div',
      {
        class: 'settings-fields'
      },
      [
        renderHeader.call(this, h, options),
        renderBody.call(this, h, options),
        renderFooter.call(this, h, options)
      ]
    )
  }
}
